import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';

@Injectable()
export class CommentsService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  postAddComment(data): Promise<any> {
    return this.http.post(environment.apiUrl + '/site-api/add-comment-order', JSON.stringify(data), {headers: this.headers})
      .toPromise()
      .then(
        function (response) {
          return response.json();
        }
      )
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/comments/comments.service.ts